
import React from 'react';
import { Image, Card, Col, Row } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const Company = ({ item }) => {
    return (
        <Card style={{ margin: 0, borderRadius: 0, borderTopWidth: 0 }} className={`cardmembership${item.membership_code}`}>
            <Row>
                <Col span={16}>
                    <h4 style={{ marginTop: 0 }}><a href={item.website} title={`${item.acronym} website`} className={`membership${item.membership_code}`}>{item.name}</a></h4>
                    <span className={`membership${item.membership_code}`}><UserOutlined /> {item.membership_label} {item.uiccregion}</span>
                </Col>
                <Col span={8} style={{ textAlign: 'right' }}>
                    <Image src={item.logo} height={40} />
                </Col>
            </Row>
        </Card>
    );
};

export default Company;
